import { TemplateFormat } from '@langchain/core/prompts';

import { RichTextEditor } from '@/components/RichTextEditor/RichTextEditor';

import { diffString } from '../../utils';
import { RenderDiff } from '../Diffs';
import { MessageDiff } from '../types';

export const CommitPromptManifest = ({
  kwargs,
}: {
  kwargs: Record<string, unknown> & {
    template_format: string;
    template: string;
    input_variables: string[];
  };
}) => {
  return (
    <div className="rounded-lg border border-secondary bg-background px-4 py-3">
      <RichTextEditor
        smallText
        variant={'template'}
        initialValue={kwargs.template as string}
        readOnly
        templateFormat={kwargs.template_format as TemplateFormat}
        onChange={() => null}
      />
    </div>
  );
};

export const CommitPromptDiff = ({
  currentCommitMsg,
  previousCommitMsg,
}: {
  currentCommitMsg: string;
  previousCommitMsg: string;
}) => {
  const diffs: MessageDiff[] = diffString(previousCommitMsg, currentCommitMsg);

  return <RenderDiff diffs={diffs} />;
};
